export default {
  id: '7cf0e560-3884-11ea-81e0-9d1459239600',
  title: "Paranormal Detective: Escape from the 80's",
  imageUrl: 'https://productionappstorage-f3b9.kxcdn.com/20204/conversions/80s_Game_Logo_Black_LG-thumbnail.jpg',
  responsiveImageUrls: [
    {
      url: 'https://productionappstorage-f3b9.kxcdn.com/20204/responsive-images/80s_Game_Logo_Black_LG___thumbnail_920_430.jpg',
      width: '920w',
    },
    {
      url: 'https://productionappstorage-f3b9.kxcdn.com/20204/responsive-images/80s_Game_Logo_Black_LG___thumbnail_769_359.jpg',
      width: '769w',
    },
    {
      url: 'https://productionappstorage-f3b9.kxcdn.com/20204/responsive-images/80s_Game_Logo_Black_LG___thumbnail_644_301.jpg',
      width: '644w',
    },
    {
      url: 'https://productionappstorage-f3b9.kxcdn.com/20204/responsive-images/80s_Game_Logo_Black_LG___thumbnail_538_251.jpg',
      width: '538w',
    },
    {
      url: 'https://productionappstorage-f3b9.kxcdn.com/20204/responsive-images/80s_Game_Logo_Black_LG___thumbnail_450_210.jpg',
      width: '450w',
    },
    {
      url: 'data:image/svg+xml;base64,PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHg9IjAiCiB5PSIwIiB2aWV3Qm94PSIwIDAgOTIwIDQzMCI+Cgk8aW1hZ2Ugd2lkdGg9IjkyMCIgaGVpZ2h0PSI0MzAiIHhsaW5rOmhyZWY9ImRhdGE6aW1hZ2UvanBlZztiYXNlNjQsLzlqLzRBQVFTa1pKUmdBQkFRQUFBUUFCQUFELzJ3QkRBQU1DQWdNQ0FnTURBd01FQXdNRUJRZ0ZCUVFFQlFvSEJ3WUlEQW9NREFzS0N3c05EaElRRFE0UkRnc0xFQllRRVJNVUZSVVZEQThYR0JZVUdCSVVGUlQvMndCREFRTUVCQVVFQlFrRkJRa1VEUXNORkJRVUZCUVVGQlFVRkJRVUZCUVVGQlFVRkJRVUZCUVVGQlFVRkJRVUZCUVVGQlFVRkJRVUZCUVVGQlFVRkJRVUZCVC93QUFSQ0FBT0FCNERBUkVBQWhFQkF4RUIvOFFBRndBQUF3RUFBQUFBQUFBQUFBQUFBQUFBQlFZSENQL0VBQ0lRQUFFREJBSUNBd0FBQUFBQUFBQUFBQUlCQkFVQUF3Y1NCaEZoZ1JNaFFmL0VBQmNCQUFNQkFBQUFBQUFBQUFBQUFBQUFBQUVDQXdUL3hBQWNFUUFEQUFJREFRQUFBQUFBQUFBQUFBQUFBUkVDQXhJaE1TTC8yZ0FNQXdFQUFoRURFUUEvQU1LNHp4ZTE1SzNRN2hKN3JOdDJQRHdaS2xIdFlQaVd2ZnlFRlYwdDVxc1Y5QWFleHhCczdaNmtIYUpXamlCVWkzSzRkcXllS05ra1VlL3lrYWdRbHdqSUx5QURXMHFxbmhhbThVL1Fwd055bVlaUzd0MFJEN3F1SHl1aWxVRStUeUJKUEZMYTZYMzVvOGhLTGptU3ZPajJ1RXFyU0NuLzJRPT0iPgoJPC9pbWFnZT4KPC9zdmc+',
      width: '32w',
    },
  ],
  videoUrl: 'https://productionappstorage-f3b9.kxcdn.com/20334/conversions/80s_trailer.webm',
  installed: false,
  keysTotal: 0,
  keysUsed: 0,
  keysAvailable: 0,
  cds: true,
  ownership: {
    id: '9633f9c0-333c-11ea-b8d3-df3b50699a1c',
    title: "Paranormal Detective: Escape from the 80's",
    description: 'As a detective specializing in unusual cases, you just found the cold case of the century!  \n\nBack in 1987, Corey Savage disappeared off the face of the earth. His parents noticed the TV and Game Glove buzzing with a strange electricity...  Could these objects hold the keys to this mystery?  Can you solve the puzzles in this preserved game room to unlock the secret of Corey’s disappearance?  Will you be transported to a retro-futuristic cyber TV world to face off against an evil villain??\n\nFilled with interactive toys and puzzles, this escape-room style game lets you explore and play. Perfect for VR enthusiasts who love retro aesthetics and 80’s throwbacks!',
    imageUrl: 'https://productionappstorage-f3b9.kxcdn.com/20203/80s_Game_Logo_Black_LG.jpg',
    responsiveImageUrls: [
      {
        url: 'https://productionappstorage-f3b9.kxcdn.com/20203/responsive-images/80s_Game_Logo_Black_LG___thumbnail_920_430.jpg',
        width: '920w',
      },
      {
        url: 'https://productionappstorage-f3b9.kxcdn.com/20203/responsive-images/80s_Game_Logo_Black_LG___thumbnail_769_359.jpg',
        width: '769w',
      },
      {
        url: 'https://productionappstorage-f3b9.kxcdn.com/20203/responsive-images/80s_Game_Logo_Black_LG___thumbnail_644_301.jpg',
        width: '644w',
      },
      {
        url: 'https://productionappstorage-f3b9.kxcdn.com/20203/responsive-images/80s_Game_Logo_Black_LG___thumbnail_538_251.jpg',
        width: '538w',
      },
      {
        url: 'https://productionappstorage-f3b9.kxcdn.com/20203/responsive-images/80s_Game_Logo_Black_LG___thumbnail_450_210.jpg',
        width: '450w',
      },
      {
        url: 'data:image/svg+xml;base64,PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHg9IjAiCiB5PSIwIiB2aWV3Qm94PSIwIDAgOTIwIDQzMCI+Cgk8aW1hZ2Ugd2lkdGg9IjkyMCIgaGVpZ2h0PSI0MzAiIHhsaW5rOmhyZWY9ImRhdGE6aW1hZ2UvanBlZztiYXNlNjQsLzlqLzRBQVFTa1pKUmdBQkFRQUFBUUFCQUFELzJ3QkRBQU1DQWdNQ0FnTURBd01FQXdNRUJRZ0ZCUVFFQlFvSEJ3WUlEQW9NREFzS0N3c05EaElRRFE0UkRnc0xFQllRRVJNVUZSVVZEQThYR0JZVUdCSVVGUlQvMndCREFRTUVCQVVFQlFrRkJRa1VEUXNORkJRVUZCUVVGQlFVRkJRVUZCUVVGQlFVRkJRVUZCUVVGQlFVRkJRVUZCUVVGQlFVRkJRVUZCUVVGQlFVRkJRVUZCVC93QUFSQ0FBT0FCNERBUkVBQWhFQkF4RUIvOFFBRndBQUF3RUFBQUFBQUFBQUFBQUFBQUFBQlFZSENQL0VBQ0lRQUFFREJBSUNBd0FBQUFBQUFBQUFBQUlCQkFVQUF3Y1NCaEZoZ1JNaFFmL0VBQmNCQUFNQkFBQUFBQUFBQUFBQUFBQUFBQUVDQXdUL3hBQWNFUUFEQUFJREFRQUFBQUFBQUFBQUFBQUFBUkVDQXhJaE1TTC8yZ0FNQXdFQUFoRURFUUEvQU1LNHp4ZTE1SzNRN2hKN3JOdDJQRHdaS2xIdFlQaVd2ZnlFRlYwdDVxc1Y5QWFleHhCczdaNmtIYUpXamlCVWkzSzRkcXllS05ra1VlL3lrYWdRbHdqSUx5QURXMHFxbmhhbThVL1Fwd055bVlaUzd0MFJEN3F1SHl1aWxVRStUeUJKUEZMYTZYMzVvOGhLTGptU3ZPajJ1RXFyU0NuLzJRPT0iPgoJPC9pbWFnZT4KPC9zdmc+',
        width: '32w',
      },
    ],
    videoWebmUrl: 'https://productionappstorage-f3b9.kxcdn.com/20333/conversions/80s_trailer.webm',
    videoMp4Url: 'https://productionappstorage-f3b9.kxcdn.com/20333/conversions/80s_trailer.mp4',
    freeDownload: true,
    headsetHtcVive: true,
    headsetOculusRift: true,
    headsetWindowsMr: false,
    displayExperienceType: 'Room Scale / Standing',
    ageRating: 0,
    difficulty: 2,
    developers: 'LunaBeat',
    publishers: 'LunaBeat',
    cds: true,
    currentAgreement: {
      id: 'f9fe9a60-37e0-11ea-aa55-bb6b6df2a315',
      content: "<p>This End-User License Agreement (\"EULA\") is a legal agreement between you and LunaBeat.</p>\n<p>This EULA agreement governs your acquisition and use of our Paranormal Detective: Escape from the 80's software (\"Software\") directly from LunaBeat or indirectly through a LunaBeat authorized reseller or distributor (a \"Reseller\").</p>\n<p>Please read this EULA agreement carefully before completing the installation process and using the Paranormal Detective: Escape from the 80's software. It provides a license to use the Paranormal Detective: Escape from the 80's software and contains warranty information and liability disclaimers.</p>\n<p>If you are entering into this EULA agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity and its affiliates to these terms and conditions. If you do not have such authority or if you do not agree with the terms and conditions of this EULA agreement, do not install or use the Software, and you must not accept this EULA agreement.</p>\n<p>This EULA agreement shall apply only to the Software supplied by LunaBeat herewith regardless of whether other software is referred to or described herein. The terms also apply to any LunaBeat updates, supplements, Internet-based services, and support services for the Software, unless other terms accompany those items on delivery. If so, those terms apply. This EULA was created by EULA Template for Paranormal Detective: Escape from the 80's.</p>\n<p>License Grant<br />LunaBeat hereby grants you a personal, non-transferable, non-exclusive license to use the Paranormal Detective: Escape from the 80's software on your devices in accordance with the terms of this EULA agreement.</p>\n<p>You are permitted to load the Paranormal Detective: Escape from the 80's software (for example a PC, laptop, mobile or tablet) under your control. You are responsible for ensuring your device meets the minimum requirements of the Paranormal Detective: Escape from the 80's software.</p>\n<p>You are not permitted to:<br />Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the Software nor permit the whole or any part of the Software to be combined with or become incorporated in any other software, nor decompile, disassemble or reverse engineer the Software or attempt to do any such things<br />Use the Software in any way which breaches any applicable local, national or international law<br />Use the Software for any purpose that LunaBeat considers is a breach of this EULA agreement</p>\n<p>Intellectual Property and Ownership<br />LunaBeat shall at all times retain ownership of the Software as originally downloaded by you and all subsequent downloads of the Software by you. The Software (and the copyright, and other intellectual property rights of whatever nature in the Software, including any modifications made thereto) are and shall remain the property of LunaBeat.</p>\n<p>LunaBeat reserves the right to grant licenses to use the Software to third parties.</p>\n<p>Termination<br />This EULA agreement is effective from the date you first use the Software and shall continue until terminated. You may terminate it at any time upon written notice to LunaBeat.</p>\n<p>It will also terminate immediately if you fail to comply with any term of this EULA agreement. Upon such termination, the licenses granted by this EULA agreement will immediately terminate and you agree to stop all access and use of the Software. The provisions that by their nature continue and survive will survive any termination of this EULA agreement.</p>\n<p>Governing Law<br />This EULA agreement, and any dispute arising out of or in connection with this EULA agreement, shall be governed by and construed in accordance with the laws of us.</p>\n<p>This EULA was last updated on Jan 10, 2020. Our EULA may change from time to time. If we make any material changes to our policies, we will place a prominent notice on our website or application. If the change materially affects registered users, we will send a notice to you by email, push notification or text.&nbsp;</p>",
      endsAt: null,
      startsAt: '2020-01-15T21:49:59+00:00',
      updatedAt: '2020-01-15T21:49:59+00:00',
      isCurrent: true,
    },
    upcomingAgreement: null,
    genres: [
      {
        id: '10',
        title: 'Escape Room',
      },
      {
        id: '14',
        title: 'Puzzle',
      },
      {
        id: '22',
        title: 'Funny',
      },
    ],
    singleplayer: true,
    multiplayer: false,
    minPlayers: 1,
    maxPlayers: 1,
    upcomingPrice: null,
    currentPrice: {
      displayPriceMinute: '6¢',
      priceMinute: 6,
    },
    minutePrice: {
      current: {
        startsAt: '2020-01-10T03:05:26+00:00',
        endsAt: null,
        price: 6,
        displayPrice: '6¢',
      },
      upcoming: null,
    },
    monthlyPrice: {
      current: {
        startsAt: '2020-01-10T03:05:26+00:00',
        endsAt: null,
        price: 1499,
        displayPrice: '$14.99',
      },
      upcoming: null,
    },
    yearlyPrice: {
      current: {
        startsAt: '2020-01-10T03:05:26+00:00',
        endsAt: null,
        price: 14499,
        displayPrice: '$144.99',
      },
      upcoming: null,
    },
    steamId: null,
    lbeVersion: false,
    communityUrl: 'https://community.springboardvr.com/d/1086-paranormal-detective-escape-from-the-80-s',
    contentGuideUrl: null,
    reviewCons: null,
    reviewPros: null,
    latestVersionDate: null,
    releaseDate: '2020-01-15T21:49:59+00:00',
    operatorGame: {
      id: '7cf0e560-3884-11ea-81e0-9d1459239600',
    },
    operatorLicense: {
      id: '7d96a050-3884-11ea-a272-89e5881d2459',
      promptForCurrentLicense: false,
      promptForUpcomingLicense: false,
      disabledForOutOfDateAgreement: false,
    },
    cannesxr: false,
    __typename: 'ContentOwnership',
  },
  preset: {
    id: '963496c0-333c-11ea-8693-298ad439477f',
  },
  organizationTags: [],
  description: 'As a detective specializing in unusual cases, you just found the cold case of the century!  \n\nBack in 1987, Corey Savage disappeared off the face of the earth. His parents noticed the TV and Game Glove buzzing with a strange electricity...  Could these objects hold the keys to this mystery?  Can you solve the puzzles in this preserved game room to unlock the secret of Corey’s disappearance?  Will you be transported to a retro-futuristic cyber TV world to face off against an evil villain??\n\nFilled with interactive toys and puzzles, this escape-room style game lets you explore and play. Perfect for VR enthusiasts who love retro aesthetics and 80’s throwbacks!',
  difficulty: 2,
  developers: 'LunaBeat',
  publishers: 'LunaBeat',
  singleplayer: true,
  multiplayer: false,
  minPlayers: 1,
  maxPlayers: 1,
  ageRating: 14,
  license: {
    endsAt: null,
    startsAt: '2020-01-16T17:20:27+00:00',
    id: '7d96a050-3884-11ea-a272-89e5881d2459',
    upcomingInvoiceAmount: {
      displayValue: '$0.00',
      value: 0,
    },
    currentTotalUsage: {
      displayValue: '0',
    },
    monthlyLicensesCount: 0,
    yearlyLicensesCount: 0,
    currentMinuteCost: {
      total: {
        displayValue: '$0.00',
      },
    },
    currentMonthlyCost: {
      quantity: 0,
      total: {
        displayValue: '$0.00',
      },
    },
    currentMinuteUsage: null,
    currentMonthlyUsage: null,
    currentYearlyUsage: null,
    monthlyLicenses: [],
    yearlyLicenses: [],
  },
  costEstimateMonth: {
    displayValue: null,
    value: null,
  },
  order: -25,
  upcomingPrice: null,
  stationsAvailable: 28,
  stationsInstalled: 1,
  currentPrice: null,
  installErrorMessage: null,
  cdsTransitionError: false,
  agreementError: false,
  updatedAt: '2020-01-16T18:38:27+00:00',
  __typename: 'Game',
  launchMethod: 'path',
  arguments: null,
  exe: '',
  filePath: null,
  uri: null,
  controlsEnabled: true,
  controlsTrigger: null,
  controlsGrip: null,
  controlsMenu: null,
  controlsTouchpad: null,
  controlsExtra: null,
  stationGames: [
    {
      id: '629b0f40-388f-11ea-ade1-3987f8483285',
      station: {
        id: '40c6d0b0-073f-11ea-80b0-13e5e4c66c63',
      },
      game: {
        id: '7cf0e560-3884-11ea-81e0-9d1459239600',
      },
      status: 'installed',
      targetStatus: 'install_pending',
      progress: null,
      eta: null,
      enabled: true,
      errorType: null,
      errorMessage: null,
      key: null,
      updatedAt: '2020-01-16 18:49:55',
    },
  ],
}
;
